import { Directive, forwardRef, Input } from '@angular/core';
import { FormControl, NG_VALIDATORS } from '@angular/forms';

@Directive({
  selector: '[validUrl]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => ValidUrlDirective),
      multi: true,
    },
  ],
  standalone: false,
})
export class ValidUrlDirective {
  validator: Function;
  @Input() httpsOnly: boolean = true;
  constructor() {}

  validate(control: FormControl) {
    if (!control?.value) return null;
    let urlValid = this.httpsOnly
      ? new RegExp(
          // Basic URL validation with protocol, domain, optional port, and optional path/query/fragment.
          // This is loose and just prevents obvious invalid URLs.
          `^https:\\/\\/[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?\\.[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?(\\.[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?)*(:\\d+)?(\\/.*)?$`
        )
      : new RegExp(
          `^https?:\\/\\/[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?\\.[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?(\\.[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?)*(:\\d+)?(\\/.*)?$`
        );

    let noWhiteSpace = new RegExp(/\s/);
    return urlValid.test(control.value) &&
      !noWhiteSpace.test(control.value.trim())
      ? null
      : {
          urlInvalid: true,
        };
  }
}
